import React, { SetStateAction, useState, useEffect } from "react";
import {
    AtualizarEmailContaController,
    GetEmailContaController,
} from "../../../../../../../Controllers/Geral/GestaoDeCadastros/EmailConta/EmailContaController";
import CreatableSelect from "react-select/creatable";
import { useForm } from "react-hook-form";
import { ModalEditarEmailPropsInterface } from "../EmailConta";
import SpinnerComponent from "../../../../../../Loding/Spinner";
import useAsyncEffect from "../../../../../../../hooks/useAsyncEffect";

interface EditNameFormData {
    DS_USERNAME: string;
    DS_HOSTNAME_SMTP: string;
    DS_SENHA: string;
    NR_PORTA_IMAP: number;
    NR_PORTA_SMTP: number;
    DS_HOSTNAME_IMAP: string;
    DS_REMETENTE: string;
}

export default function ModalEditarEmailConta(
    props: ModalEditarEmailPropsInterface
) {
    const { ID_EMAIL_CONTA, updateList } = props;

    const [showPass, setShowPass] = useState<boolean>(false);

    const [copiaCarbono, setCopiaCarbono] = useState<Array<string>>([]);
    const [copiaCarbonoOculta, setCopiaCarbonoOculta] = useState<Array<string>>([]);

    const { register, handleSubmit, formState, setValue } = useForm<EditNameFormData>();

    const {
        value: getEmail,
        loading: getEmailLoading,
        execute: getEmailExecute,
    } = useAsyncEffect(() => {
        return GetEmailContaController(ID_EMAIL_CONTA);
    }, [ID_EMAIL_CONTA]);

    useEffect(() => {
        if (getEmail) {
            const copiaCarbonoArray: string[] = Array.isArray(getEmail.DS_COPIA) ? getEmail.DS_COPIA : [];
            const copiaCarbonoOcultaArray: string[] = Array.isArray(getEmail.DS_COPIA_OCULTA) ? getEmail.DS_COPIA_OCULTA : [];
    
            setCopiaCarbono(copiaCarbonoArray);
            setCopiaCarbonoOculta(copiaCarbonoOcultaArray);
            setValue("DS_USERNAME", getEmail.DS_USERNAME);
            setValue("DS_HOSTNAME_SMTP", getEmail.DS_HOSTNAME_SMTP);
            setValue("DS_SENHA", getEmail.DS_SENHA);
            setValue("NR_PORTA_IMAP", getEmail.NR_PORTA_IMAP);
            setValue("NR_PORTA_SMTP", getEmail.NR_PORTA_SMTP);
            setValue("DS_HOSTNAME_IMAP", getEmail.DS_HOSTNAME_IMAP);
            setValue("DS_REMETENTE", getEmail.DS_REMETENTE);
        }
    }, [getEmail, setValue]);

    function handleEditNameForm(data: EditNameFormData) {
        AtualizarEmailContaController({
            ID_EMAIL_CONTA: ID_EMAIL_CONTA,
            DS_USERNAME: data.DS_USERNAME,
            DS_HOSTNAME_SMTP: data.DS_HOSTNAME_SMTP,
            DS_SENHA: data.DS_SENHA,
            NR_PORTA_IMAP: data.NR_PORTA_IMAP,
            NR_PORTA_SMTP: data.NR_PORTA_SMTP,
            FL_SSL: getEmail?.FL_SSL || false,
            DS_HOSTNAME_IMAP: data.DS_HOSTNAME_IMAP,
            FL_VALIDADO: getEmail?.FL_VALIDADO || false,
            DS_REMETENTE: data.DS_REMETENTE,
            DS_COPIA: copiaCarbono,
            DS_COPIA_OCULTA: copiaCarbonoOculta,
        }).then(() => {
            getEmailExecute(ID_EMAIL_CONTA);
            updateList();
        });
    }

    const optionsCopiaCarbono = (copiaCarbono || []).map(email => ({
        label: email,
        value: email
    }));

    const optionsCopiaCarbonoOculta = (copiaCarbonoOculta || []).map(email => ({
        label: email,
        value: email
    }));

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out"
        })
    };

    return !getEmailLoading ? (
        <div className="p-5">
            <div className="row d-flex align-items-center justify-content-center">
                <form
                    className=" row"
                    id="group-name-edit-form"
                    onSubmit={handleSubmit(handleEditNameForm)}
                >
                    <div className="row col-12 p-0">
                        <div className="col-8 p-0">
                            <span>Usuário</span>
                            <input
                                className={`form-control placeholder-dark-75 ${
                                    formState.errors.DS_USERNAME && "is-invalid"
                                }`}
                                type="text"
                                defaultValue={getEmail?.DS_USERNAME}
                                name="DS_USERNAME"
                                autoComplete="off"
                                ref={register({
                                    required: true,
                                })}
                            />
                        </div>

                        <div className="col-4 p-0 pl-1">
                            <span>Senha</span>
                            <div className="input-group">
                                <input
                                    className={`form-control colomun placeholder-dark-75 ${
                                        formState.errors.DS_SENHA &&
                                        "is-invalid"
                                    }`}
                                    type={!!showPass ? `text` : `password`}
                                    defaultValue={getEmail?.DS_SENHA}
                                    name="DS_SENHA"
                                    autoComplete="off"
                                    id="DS_SENHA"
                                    ref={register({
                                        required: true,
                                    })}
                                />
                                <div
                                    onMouseEnter={() => {
                                        setShowPass(true);
                                    }}
                                    onMouseOut={() => {
                                        setShowPass(false);
                                    }}
                                    id="password"
                                    className="input-group-append"
                                >
                                    <button
                                        className="btn btn-secondary p-2"
                                        type="button"
                                    >
                                        <i
                                            className={
                                                !!showPass
                                                    ? `fas fa-eye`
                                                    : ` fas fa-eye-slash`
                                            }
                                            style={{ fontSize: 13, padding: 0 }}
                                            onMouseEnter={() => {
                                                setShowPass(true);
                                            }}
                                            onMouseOut={() => {
                                                setShowPass(false);
                                            }}
                                        ></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row col-12 p-0">
                        <div className="col-10 p-0">
                            <span>Host SMTP</span>
                            <input
                                className={`form-control placeholder-dark-75 ${
                                    formState.errors.DS_HOSTNAME_SMTP &&
                                    "is-invalid"
                                }`}
                                type="text"
                                defaultValue={getEmail?.DS_HOSTNAME_SMTP}
                                name="DS_HOSTNAME_SMTP"
                                ref={register({
                                    required: true,
                                })}
                            />
                        </div>
                        <div className="col-2 p-0 pl-1">
                            <span>Porta SMTP</span>
                            <input
                                className={`form-control placeholder-dark-75 ${
                                    formState.errors.NR_PORTA_SMTP &&
                                    "is-invalid"
                                }`}
                                type="text"
                                defaultValue={getEmail?.NR_PORTA_SMTP}
                                name="NR_PORTA_SMTP"
                                ref={register({
                                    required: true,
                                })}
                            />
                        </div>
                    </div>
                    <div className="row col-12 p-0">
                        <div className="col-10 p-0">
                            <span>Host IMAP</span>
                            <input
                                className={`form-control placeholder-dark-75 ${
                                    formState.errors.DS_HOSTNAME_IMAP &&
                                    "is-invalid"
                                }`}
                                type="text"
                                defaultValue={getEmail?.DS_HOSTNAME_IMAP}
                                name="DS_HOSTNAME_IMAP"
                                ref={register({
                                    required: false,
                                })}
                            />
                        </div>
                        <div className="col-2 p-0 pl-1">
                            <span>Porta IMAP</span>
                            <input
                                className={`form-control placeholder-dark-75 ${
                                    formState.errors.NR_PORTA_IMAP &&
                                    "is-invalid"
                                }`}
                                type="text"
                                defaultValue={getEmail?.NR_PORTA_IMAP}
                                name="NR_PORTA_IMAP"
                                ref={register({
                                    required: false,
                                })}
                            />
                        </div>
                    </div>
                    <div className="row col-12 p-0">
                        <div className="col-10 p-0">
                            <span>Rementente</span>
                            <input
                                className={`form-control placeholder-dark-75 ${
                                    formState.errors.DS_REMETENTE &&
                                    "is-invalid"
                                }`}
                                type="text"
                                defaultValue={getEmail?.DS_REMETENTE}
                                name="DS_REMETENTE"
                                ref={register({
                                    required: true,
                                })}
                            />
                        </div>
                        <div className="col-2 p-0 pl-1 ">
                            <div className="d-flex align-items-center justify-content-center">
                                <span>SSL</span>
                            </div>
                            <span
                                className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center mt-1"
                                data-toggle="tooltip"
                            >
                                <label>
                                    <input
                                        id="fL_ATIVO_STATUS"
                                        name="FL_SSL"
                                        checked={getEmail?.FL_SSL || false}
                                        type="checkbox"
                                        onChange={() => {
                                            AtualizarEmailContaController({
                                                ID_EMAIL_CONTA:
                                                    getEmail?.ID_EMAIL_CONTA ||
                                                    0,
                                                DS_USERNAME:
                                                    getEmail?.DS_USERNAME || "",
                                                FL_SSL: !getEmail?.FL_SSL,
                                                DS_HOSTNAME_SMTP:
                                                    getEmail?.DS_HOSTNAME_SMTP ||
                                                    "",
                                                DS_SENHA:
                                                    getEmail?.DS_SENHA || "",
                                                NR_PORTA_IMAP:
                                                    getEmail?.NR_PORTA_IMAP ||
                                                    0,
                                                NR_PORTA_SMTP:
                                                    getEmail?.NR_PORTA_SMTP ||
                                                    0,
                                                DS_HOSTNAME_IMAP:
                                                    getEmail?.DS_HOSTNAME_IMAP ||
                                                    "",
                                                FL_VALIDADO:
                                                    getEmail?.FL_VALIDADO ||
                                                    false,
                                                DS_REMETENTE:
                                                    getEmail?.DS_REMETENTE ||
                                                    "",
                                                DS_COPIA:
                                                    getEmail?.DS_COPIA || "",
                                                DS_COPIA_OCULTA:
                                                    getEmail?.DS_COPIA_OCULTA ||
                                                    "",
                                            }).then((response) => {
                                                getEmailExecute(
                                                    getEmail?.ID_EMAIL_CONTA
                                                );
                                                updateList();
                                            });
                                        }}
                                    />
                                    <span></span>
                                </label>
                            </span>
                        </div>
                    </div>
                    <div className="row col-12 p-0">
                        <label>Cópia Carbono</label>
                        <CreatableSelect
                            isMulti
                            isClearable
                            isSearchable
                            onChange={(e) => {
                                setCopiaCarbono(e.map(value => value?.value) as string[]);
                            }}
                            className="placeholder-dark-75 w-100"
                            formatCreateLabel={(value) => `Clique para selecionar: ${value}`}
                            styles={customStyles}
                            placeholder={"Digite o email"}
                            options={optionsCopiaCarbono}
                            value={optionsCopiaCarbono.filter(option => copiaCarbono.includes(option.value))}
                        />
                    </div>
                    <div className="row col-12 p-0">
                        <label>Cópia Carbono Oculta</label>
                        <CreatableSelect
                            isMulti
                            isClearable
                            isSearchable
                            onChange={(e) => {
                                setCopiaCarbonoOculta(e.map(value => value?.value) as string[]);
                            }}
                            className="placeholder-dark-75 w-100"
                            formatCreateLabel={(value) => `Clique para selecionar: ${value}`}
                            styles={customStyles}
                            placeholder={"Digite o email"}
                            options={optionsCopiaCarbonoOculta}
                            value={optionsCopiaCarbonoOculta.filter(option => copiaCarbonoOculta.includes(option.value))}
                        />
                    </div>                    <div className="d-flex flex-wrap justify-content-center align-items-center">
                        <button
                            type="submit"
                            id="kt_login_signin_submit"
                            className="btn btn-outline-info font-weight-bold px-9 py-4"
                        >
                            Salvar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    ) : (
        <SpinnerComponent />
    );
}
